import AutoDiscoveryBanner from './AutoDiscoveryBanner';

export default AutoDiscoveryBanner;
